import { render, staticRenderFns } from "./EmployeedetailsPage.vue?vue&type=template&id=bcece096"
import script from "./EmployeedetailsPage.vue?vue&type=script&lang=js"
export * from "./EmployeedetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports